var Zakeke;
(function (Zakeke) {
    var culture = "en-US";
    $(document).ready(function () {
        // DOM
        var viewbag = $("#viewbag");
        culture = viewbag.data("culture");
        $("#dlg-help").dialog({
            style: "predefined-dialog",
            icon: "live_help",
            iconType: "vector",
            buttons: [
                {
                    label: T._("Send", "Admin"),
                    func: function () {
                        setupHelpForm(this);
                    }
                }
            ]
        });
        // Open help form
        $("#help-button").click(function () {
            $("#dlg-help").dialog("show");
        });
    });
    // FUNCTION to send help request
    function setupHelpForm(button) {
        var token = $("input[name='__RequestVerificationToken']").val();
        var message = $("#txt-help-message").val();
        // if the message is empty or is null...
        if (message == "" || message == null) {
            Zakeke.showWarning(T._("There's no message.", "Admin"));
            return;
        }
        else // else, if the message contains at least one character...
         {
            button.attr("disabled", "true");
            $("#img-help-loading").show();
            $.post("/" + culture + "/SendAuthHelpMessage", {
                __RequestVerificationToken: token,
                message: message
            }).done(function (response) {
                Zakeke.showSuccess(T._("Message successfully sent!", "Admin"));
                // clear input message
                $("#txt-help-message").val('');
            }).fail(function (response) {
                if (response.responseJSON.result == "INVALID_FIELDS") {
                    Zakeke.showWarning(T._("Invalid text message.", "Admin"));
                }
                else if (response.responseJSON.result == "USER_NOT_LOGGED") {
                    Zakeke.showWarning(T._("You're not logged in.", "Admin"));
                }
                else {
                    Zakeke.showError(T._("Something wrong happened. Try later.", "Admin"));
                }
            }).always(function () {
                $("#img-help-loading").hide();
                $("#dlg-help").dialog("hide");
                button.removeAttr("disabled");
            });
        }
    }
})(Zakeke || (Zakeke = {}));
